<template>
  <div
    class="w-full inline-flex rounded-md bg-slate-100 overflow-hidden"
    role="tablist"
    aria-label="Button tabs"
  >
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      role="tab"
      :aria-selected="modelValue === opt.value"
      @click="!isDisabled(opt) && select(opt.value)"
      :disabled="isDisabled(opt)"
      :class="[
        'flex-1 px-4 py-2 text-sm font-medium text-center focus:outline-none transition-colors duration-150',
        modelValue === opt.value
          ? 'bg-sky-600 text-white shadow'
          : 'text-gray-700 hover:bg-sky-50 hover:text-sky-700',
        isDisabled(opt)
          ? 'opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-700'
          : 'focus:ring-0 focus:ring-sky-500'
      ]"
    >
      {{ opt.label }}
    </button>
  </div>

  <!-- Optional helper text slot below the tabs -->
  <div v-if="$slots.default" class="mt-2 text-sm text-gray-600">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonTabs',
  props: {
    options: {
      type: Array,
      required: true, // [{ label, value, disabled? }]
      validator(arr) {
        return (
          Array.isArray(arr) &&
          arr.length >= 1 &&
          arr.every(o => 'label' in o && 'value' in o)
        );
      },
    },
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  mounted() {
    const has = this.options.some(o => o.value === this.modelValue);
    if (!has) {
      const first = this.options[0]?.value;
      if (first !== undefined) this.$emit('update:modelValue', first);
    }
  },
  watch: {
    options: {
      handler(newOpts) {
        const has = newOpts.some(o => o.value === this.modelValue);
        if (!has && newOpts.length)
          this.$emit('update:modelValue', newOpts[0].value);
      },
      deep: true,
    },
  },
  methods: {
    isDisabled(opt) {
      return this.disabled || opt.disabled === true;
    },
    select(val) {
      if (val === this.modelValue) return;
      this.$emit('update:modelValue', val);
      this.$emit('change', val);
    },
  },
};
</script>

<style scoped>
</style>
